import React from 'react';
import { Link } from 'react-router-dom';

import './Logo.scss';
// import LogoUrl from '../../../../asset/images/logo_transparent.png';

const Logo = ({ width, height, className }) => {
  return (
    <Link to="/">
      <h1 className={`logo ${className}`}>
        xxxxx
        <br />
        xxxxxxxx
      </h1>
    </Link>
  );
};

export default Logo;
